import React, { forwardRef, useEffect, useState } from 'react';
import moment from 'moment';
import i18n from 'Douleutaras/lib/i18n';
import { LANGUAGE_CODES } from 'Douleutaras/constants/system';
import { DATE_FIELD_FORMAT } from 'Douleutaras/constants/date';
import { LANGUAGE_CONFIG } from 'Douleutaras/constants/localization';
import CustomDatepicker from 'Douleutaras/components/CustomDatepicker/CustomDatepicker';

import './DateField.scss';

interface ButtonComponentProps {
  value?: Date;
  noDateByDefault?: boolean;
  onClick?(): void;
}

export const DateField = ({ input, noDateByDefault = false }) => {
  const [date, setDate] = useState();
  const [pickerProps, setPickerProps] = useState({});
  const currentLang = i18n.language as LANGUAGE_CODES;
  const dateFormat = LANGUAGE_CONFIG.DATEPICKER.DISPLAY_FORMAT.DATE[currentLang];

  const ButtonComponent = ({ value, onClick }, ref) => {
    return (
      <button styleName="custom-date" onClick={onClick} ref={ref} type="button">
        <span styleName="custom-date__text">{value}</span>
        <span styleName="custom-date__icon"
              className="dashicon dashicon-event" />
      </button>
    );
  };
  const DateTemplate = forwardRef<HTMLButtonElement, ButtonComponentProps>(ButtonComponent);

  const handleChange = val => {
    // react-datepicker can fire onChange(null) on touch devices (e.g. a stray tap on the
    // calendar popover) — moment(null) formats to the literal string "Invalid date", which
    // then gets submitted as the field's value and rejected by the API.
    if (!val) {
      return;
    }

    setDate(val);
    // tslint:disable-next-line:newline-per-chained-call
    input.onChange(moment(val).format(DATE_FIELD_FORMAT));
  };

  useEffect(() => {
    if (input.value) {
      // tslint:disable-next-line:newline-per-chained-call
      handleChange(moment.utc(input.value, DATE_FIELD_FORMAT).toDate());
    }
  }, [input.value]);

  useEffect(() => {
    if (!input.value && !noDateByDefault) {
      handleChange(new Date());
    }
    if (input.pickerProps) {
      setPickerProps(input.pickerProps);
    }
  }, []);

  return (
    <CustomDatepicker datepickerProps={{
      selected: date,
      onChange: handleChange,
      dateFormat,
      customInput: <DateTemplate />,
      ...pickerProps
    }}
    />
  );
};
